import { Brand, createBranded } from '@deltasierra/type-utilities';

export type PublishedArtifactId = Brand<number, 'PublishedArtifactId'>;
export const PublishedArtifactId = createBranded<PublishedArtifactId>();
